import {
  HOME_SYNC_WORKERS_WITH_PCO_BEGIN,
  HOME_SYNC_WORKERS_WITH_PCO_SUCCESS,
  HOME_SYNC_WORKERS_WITH_PCO_FAILURE,
  HOME_SYNC_WORKERS_WITH_PCO_DISMISS_ERROR,
} from './constants';

import axios from 'axios';
import {makeDictionary} from '../../common/util'
import { fetchModelData} from './fetchModelData';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function syncWorkersWithPco(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_SYNC_WORKERS_WITH_PCO_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
       axios.post("/api/values/SyncWorkersWithPco").then(
        (res) => {
          dispatch(fetchModelData());//reload missing properties, role/loc availabilities and all that stuff
          dispatch({
            type: HOME_SYNC_WORKERS_WITH_PCO_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_SYNC_WORKERS_WITH_PCO_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSyncWorkersWithPcoError() {
  return {
    type: HOME_SYNC_WORKERS_WITH_PCO_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_SYNC_WORKERS_WITH_PCO_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        syncWorkersWithPcoPending: true,
        syncWorkersWithPcoError: null,
      };

    case HOME_SYNC_WORKERS_WITH_PCO_SUCCESS:
      // The request is success
      return {
        ...state,
        syncWorkersWithPcoPending: false,
        syncWorkersWithPcoError: null,
        workers: makeDictionary(action.data.workers),
        syncWorkersWithPcoMessages: action.data.messages
      };

    case HOME_SYNC_WORKERS_WITH_PCO_FAILURE:
      // The request is failed
      return {
        ...state,
        syncWorkersWithPcoPending: false,
        syncWorkersWithPcoError: action.data.error,
      };

    case HOME_SYNC_WORKERS_WITH_PCO_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        syncWorkersWithPcoError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/syncWorkersWithPco.js